export const matchTypes = [
  'specialty',
  'facility_type',
  'practitioner',
] as const;

export type ProviderSearchQueryMatchType = (typeof matchTypes)[number];

export interface ProviderSearchQueryValues {
  text: string;
  matchId?: string;
  matchType?: ProviderSearchQueryMatchType;
}

export interface ProviderSearchLocationValues {
  text: string;
  latitude?: number;
  longitude?: number;
}

export interface ProviderSearchValues {
  query: ProviderSearchQueryValues;
  location: ProviderSearchLocationValues;
}
